import {
    INIT_NAVIGATION,
    PREVIOUS_MEDIA,
    NEXT_MEDIA,
    JUMP_TO_MEDIA,
    FORWARD_MEDIA,
    BACKWARD_MEDIA,
    FIRST_MEDIA,
    LAST_MEDIA,
} from './actions'

import { pick } from 'lodash'

export const navigation = (state = {}, { type, ...action}) => {
    switch (type)
    {
        case INIT_NAVIGATION:
            return action.navigation
        case JUMP_TO_MEDIA:
        case PREVIOUS_MEDIA:
        case NEXT_MEDIA:
        case FORWARD_MEDIA:
        case BACKWARD_MEDIA:
        case FIRST_MEDIA:
        case LAST_MEDIA:
            const { navigation } = action

            if(state.media.position === navigation.media.position) return state

            return {
                ...navigation,
                media: { ...state.media, ...pick(navigation.media, ['hasNext', 'hasPrevious', 'position']) },
            }
        default:
            return state
    }
}
